/* istanbul ignore file */
/**
 * GS1 Application Identifiers (AIs) mapping.
 * This module exports a mapping of GS1 Application Identifiers to their corresponding fields.
 * The keys are the AIs, and the values are the fields they map to.
 * @see https://ref.gs1.org/ai/  for the full list of GS1 Application Identifiers
 *
 * @module APPLICATION_IDENTIFIERS
 */
module.exports = {
    '01': ['item:model', 'title'], //'GTIN',
    '03': ['item:model', 'title'], //'MTO_GTIN',
    10: 'lotNo',
    15: 'expirationDate', //BEST_BEFORE,
    16: 'expirationDate', //'SELL_BY',
    17: 'expirationDate', //'EXPIRY',
    21: 'serialNo', //'SERIAL',
    // 235: 'serialNo', // TPX: '3rd party controlled serial?',
    414: 'title', //'LOC_NO',
    8003: 'title', //'GRAI', // global returnable asset identifier
    8004: 'title', //'GIAI' // global individual asset identifier
    8013: ['item:model', 'title'] // GMN // Global Model Number
};
